import styled from "styled-components";

export const WalkthroughHeading = styled.h1`
  grid-column: span 2;
  text-align: center;
  font-size: 2rem;
  font-weight: 2rem;
  margin-top: 20px;
  color: #3393f0;
`;

export const WalkthroughContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 20px;
  max-width: 1200px;
  top: -120px;
  gap: 20px;
  margin: 20px auto;
  position: relative;
  background-image: url("/assets/bg_2.png");
  background-repeat: no-repeat;
  background-size: 30%;
  background-position: right center;

  @media (max-width: 1400px) {
    flex-direction: column;
    background-image: none;
    width: 100%;
  }

  @media (max-width: 800px) {
    background-image: url("/assets/bg_2.png");
    background-position: center;
    top: -40px;
  }
`;

export const WalkthroughImage = styled.img`
  object-fit: cover;
  width: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
  border: 2px solid white;

  @media (max-width: 1400px) {
    width: 100%;
    margin: 20px auto;
  }
`;

export const WalkthroughTextContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 40px;
  padding: 20px;
  font-size: 12px;
  width: 50%;

  @media (max-width: 1400px) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const WalkthroughTextBox = styled.div`
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #3393f0;
  text-align: left;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  color: white;
  width: 100%;
  background: linear-gradient(135deg, #3393f0 0%, rgb(37, 105, 173) 100%);
  transition: opacity 1.5s ease, transform 1.5s ease, visibility 0s 1.5s;

  &:hover {
    transform: translateY(-20px);
  }
`;

export const WalkthroughTextBoxTitle = styled.h3`
  margin-bottom: 15px;
`;
